export default __webpack_public_path__ + "static/media/logomicyda2.0ee3223e.svg";